// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class NotImplementedModule extends ModuleBase {
  @Prop({ default: "ErrorWidget" })
  public type!: string;

  getBackgroundColorFromInstance(instance: object) {
    return "black";
  }
}
